export default "__VITE_ASSET__B_JwI8VB__"